/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AgelessMarketingDeploymentChecklistProgressForPlatformRetrievedResponse
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieves a platform's Ageless marketing deployment checklist progress.
 */
export const getDeploymentChecklistProgress = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<AgelessMarketingDeploymentChecklistProgressForPlatformRetrievedResponse>(
      {url: `/api/v1/ageless/${platformId}/marketing/deployment-checklist`, method: 'GET', signal
    },
      );
    }




export const getGetDeploymentChecklistProgressQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/${platformId}/marketing/deployment-checklist`
    ] as const;
    }


export const getGetDeploymentChecklistProgressQueryOptions = <TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeploymentChecklistProgressQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>> = ({ signal }) => getDeploymentChecklistProgress(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeploymentChecklistProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>>
export type GetDeploymentChecklistProgressQueryError = ErrorType<unknown>


export function useGetDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeploymentChecklistProgress>>,
          TError,
          Awaited<ReturnType<typeof getDeploymentChecklistProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeploymentChecklistProgress>>,
          TError,
          Awaited<ReturnType<typeof getDeploymentChecklistProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a platform's Ageless marketing deployment checklist progress.
 */

export function useGetDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeploymentChecklistProgressQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDeploymentChecklistProgressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeploymentChecklistProgressQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>> = ({ signal }) => getDeploymentChecklistProgress(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDeploymentChecklistProgressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>>
export type GetDeploymentChecklistProgressSuspenseQueryError = ErrorType<unknown>


export function useGetDeploymentChecklistProgressSuspense<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeploymentChecklistProgressSuspense<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeploymentChecklistProgressSuspense<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a platform's Ageless marketing deployment checklist progress.
 */

export function useGetDeploymentChecklistProgressSuspense<TData = Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeploymentChecklistProgressSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Marks an Ageless marketing deployment checklist item as completed for a platform.
 */
export const markChecklistItemAsCompleted = (
    platformId: string,
    itemSlug: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/${platformId}/marketing/deployment-checklist/items/${itemSlug}/complete`, method: 'POST', signal
    },
      );
    }




export const getMarkChecklistItemAsCompletedMutationKey = () => ['markChecklistItemAsCompleted'] as const;

export const getMarkChecklistItemAsCompletedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>, TError,MarkChecklistItemAsCompletedMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>, TError,MarkChecklistItemAsCompletedMutationVariables, TContext> => {

const mutationKey = getMarkChecklistItemAsCompletedMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>, MarkChecklistItemAsCompletedMutationVariables> = (props) => {
          const {platformId,itemSlug} = props ?? {};

          return  markChecklistItemAsCompleted(platformId,itemSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkChecklistItemAsCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>>

    export type MarkChecklistItemAsCompletedMutationError = ErrorType<unknown>
    export type MarkChecklistItemAsCompletedMutationVariables = {platformId: string;itemSlug: string}

    /**
 * @summary Marks an Ageless marketing deployment checklist item as completed for a platform.
 */
export const useMarkChecklistItemAsCompleted = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsCompleted>>, TError,MarkChecklistItemAsCompletedMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markChecklistItemAsCompleted>>,
        TError,
        MarkChecklistItemAsCompletedMutationVariables,
        TContext
      > => {
      return useMutation(getMarkChecklistItemAsCompletedMutationOptions(options), queryClient);
    }
    /**
 * @summary Marks an Ageless marketing deployment checklist item as incomplete for a platform.
 */
export const markChecklistItemAsIncomplete = (
    platformId: string,
    itemSlug: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/${platformId}/marketing/deployment-checklist/items/${itemSlug}/complete`, method: 'DELETE', signal
    },
      );
    }




export const getMarkChecklistItemAsIncompleteMutationKey = () => ['markChecklistItemAsIncomplete'] as const;

export const getMarkChecklistItemAsIncompleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>, TError,MarkChecklistItemAsIncompleteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>, TError,MarkChecklistItemAsIncompleteMutationVariables, TContext> => {

const mutationKey = getMarkChecklistItemAsIncompleteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>, MarkChecklistItemAsIncompleteMutationVariables> = (props) => {
          const {platformId,itemSlug} = props ?? {};

          return  markChecklistItemAsIncomplete(platformId,itemSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkChecklistItemAsIncompleteMutationResult = NonNullable<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>>

    export type MarkChecklistItemAsIncompleteMutationError = ErrorType<unknown>
    export type MarkChecklistItemAsIncompleteMutationVariables = {platformId: string;itemSlug: string}

    /**
 * @summary Marks an Ageless marketing deployment checklist item as incomplete for a platform.
 */
export const useMarkChecklistItemAsIncomplete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>, TError,MarkChecklistItemAsIncompleteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markChecklistItemAsIncomplete>>,
        TError,
        MarkChecklistItemAsIncompleteMutationVariables,
        TContext
      > => {
      return useMutation(getMarkChecklistItemAsIncompleteMutationOptions(options), queryClient);
    }
